import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, take, takeUntil } from 'rxjs';

import { Permission } from 'src/app/shared/constants/permissions';
import * as fromStore from 'src/app/store/';
import { widgetTypes } from '../widget-types';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DashboardComponent implements OnInit, OnDestroy {
  private store = inject(Store<fromStore.State>);

  widgetTypes = widgetTypes;

  browserSize$: Observable<string> = this.store.select(
    fromStore.getBrowserSizeName,
  );

  browserSize: string;

  orionUrl$ = this.store.select(fromStore.getOrionURL);

  Permission = Permission;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.browserSize$.pipe(takeUntil(this.destroy$)).subscribe((name) => {
      if (name) this.browserSize = name;
    });

    this.store
      .select(fromStore.getTicketsLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadTickets());
        }
      });

    this.store
      .select(fromStore.getInvoicesLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadInvoices());
        }
      });

    this.store
      .select(fromStore.getPaymentsLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadPayments());
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
